<template>
  <div class="container text-right">
    <div class="row my-3">
      <b-col md="4" class="mb-4">
        <feature-search @selectedFeature="setSelectedFeatures" :filterFunction="filterFeatureItem"/>
      </b-col>
      <b-col md="8">
        <p class="m-0 p-0">موارد انتخاب شده:</p>

        <div class="btn btn-primary d-inline-block m-1" v-for="(item,index) in selectedFeatures"
             @click="removeSelectedFeatureItem(index)">
        <span>
          {{ item.name }}
        <b-icon class="h4" icon="x"/>
        </span>
        </div>
      </b-col>
      <div class="col-lg-12 text-left">
        <b-btn variant="primary" @click="generateFeatureAttributesCombination()">ساخت حالات</b-btn>
      </div>
    </div>

    <hr>

    <div class="col-lg-12">
      <div class="input-group mb-3" v-for="feature in featureCombinationOptions">

        <input disabled readonly type="text" class="form-control text-right"
               :value="setCombinationFeatureItemName(feature)">
        <div class="input-group-prepend" @click="addFeatureToProductWrapper(feature)">
          <span class="input-group-text">
            <b-icon icon="check-circle"/>
          </span>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import FeatureSearch from "./FeatureSearch.vue";
import {addFeatureToProduct, baseFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "VariationFeatureGenerator",
  components: {FeatureSearch},
  props: {
    product: {},
  },
  data() {
    return {
      baseFeature,
      searchWord: '',
      selectedFeatures: [],
      featureCombinationOptions: [],
    };
  },
  computed: {
    ...mapGetters({
      features: 'Feature/getFilteredFeatures'
    }),
    isPageInUpdateMode() {
      return this.$route.params.slug
    }
  },
  methods: {
    addFeatureToProduct,
    generateHash,
    searchFeature() {
      if (this.searchWord != "") {
        const searchWord = {words: this.searchWord};
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      }
    },
    filterFeatureItem(featureItem) {
      return featureItem.type === 'list'
    },
    setSelectedFeatures(feature) {
      this.selectedFeatures.push(feature)
    },
    removeSelectedFeatureItem(featureIndex) {
      this.selectedFeatures.splice(featureIndex, 1)
    },
    cartesian(arrays) {
      // یک آرایه خالی برای نگهداری نتایج
      let result = [];
      // یک شمارنده برای پیمایش آرایه‌ها
      let index = 0;

      // یک تابع بازگشتی برای اضافه کردن زوج‌های جدید به نتیجه
      function addToResult(prefix) {
        // اگر شمارنده به آخرین آرایه رسید، همه عناصر آن را با پیشوند جاری ترکیب می‌کنیم و به نتیجه اضافه می‌کنیم
        if (index === arrays.length - 1) {
          for (let i = 0; i < arrays[index].length; i++) {
            result.push(prefix.concat([arrays[index][i]]));
          }
        } else {
          // در غیر این صورت، همه عناصر آرایه جاری را با پیشوند جاری ترکیب می‌کنیم و شمارنده را یک واحد افزایش می‌دهیم و تابع را بازگشت می‌دهیم
          for (let i = 0; i < arrays[index].length; i++) {
            index++;
            addToResult(prefix.concat([arrays[index - 1][i]]));
            index--;
          }
        }
      }

      // فراخوانی تابع بازگشتی با یک آرایه خالی به عنوان پیشوند
      addToResult([]);
      // برگرداندن نتیجه
      return result;
    },
    generateFeatureAttributesCombination() {

      let attributes = []
      this.selectedFeatures.forEach((item, index) => {
        attributes[index] = []
        item.feature_attributes.forEach(attributeItem => {
          attributes[index].push(attributeItem)
        })
      })


      this.featureCombinationOptions = this.cartesian(attributes)
    },
    setCombinationFeatureItemName(featureItem) {
      let name = [];
      featureItem.forEach(item => {
        name.push(item.value)
      })
      return name.join(' - ')
    },
    addFeatureToProductWrapper(feature) {

      this.addFeatureToProduct({selectedFeature: this.selectedFeatures, attributes: feature}, this.product)
      toast("با موفقیت اضافه شد", "با موفقیت اضافه شد")
    }
  }
}
</script>

<style scoped>

</style>